module.exports = __webpack_public_path__ + "static/absolutecard-d6c64955f207b7391610b5b3fe4f9994.webp";